import { useEffect, useState } from 'react';

export function useTimeExpiration(dateTime: Date, thresholdSeconds = 5) {
  const [isExpired, setIsExpired] = useState(() => {
    if (!dateTime) return false;
    const targetTime = new Date(dateTime).getTime() + thresholdSeconds * 1000;
    return targetTime - Date.now() <= 0;
  });

  useEffect(() => {
    if (!dateTime) {
      setIsExpired(false);
      return;
    }

    const targetTime = new Date(dateTime).getTime() + thresholdSeconds * 1000;
    const timeUntilExpiration = targetTime - Date.now();

    if (timeUntilExpiration <= 0) {
      setIsExpired(true);
      return;
    }

    setIsExpired(false);
    const timeoutId = setTimeout(() => setIsExpired(true), timeUntilExpiration);
    return () => clearTimeout(timeoutId);
  }, [dateTime, thresholdSeconds]);

  return isExpired;
}
